"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_svg_1 = require("react-svg");
var bold_svg_1 = __importDefault(require("./assets/bold.svg"));
var italic_svg_1 = __importDefault(require("./assets/italic.svg"));
var link_svg_1 = __importDefault(require("./assets/link.svg"));
var ol_svg_1 = __importDefault(require("./assets/ol.svg"));
var ul_svg_1 = __importDefault(require("./assets/ul.svg"));
var underline_svg_1 = __importDefault(require("./assets/underline.svg"));
var Icon_1 = __importDefault(require("../Icon"));
var Typography_1 = __importDefault(require("../Typography"));
var getCSSRules = function (_a) {
    var _b;
    var colors = _a.colors, breakpoints = _a.breakpoints;
    return ({
        active: {
            stroke: colors.Hannibal[300],
        },
        button: {
            alignItems: 'center',
            backgroundColor: 'transparent',
            border: 'none',
            columnGap: 8,
            cursor: 'pointer',
            display: 'flex',
            flexShrink: 0,
            flexWrap: 'nowrap',
            justifyConent: 'center',
            padding: 0,
            '& svg': {
                align: 'middle',
            },
            '> *': {
                pointerEvents: 'none',
            },
            '&:disabled': {
                cursor: 'not-allowed',
            },
        },
        divider: {
            backgroundColor: colors.Grey[300],
            width: 1,
            height: 24,
        },
        disabled: {
            stroke: colors.Grey[300],
        },
        wrapper: (_b = {
                alignItems: 'center',
                backgroundColor: colors.Grey[100],
                columnGap: 20,
                display: 'flex',
                overflowX: 'auto',
                padding: '10px 12px'
            },
            _b["@media (max-width: ".concat(breakpoints.sm, "px)")] = {
                columnGap: 10,
            },
            _b),
        icon: {
            stroke: colors.Grey[700],
        },
    });
};
var MenuButton = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, icon = _a.icon, onClick = _a.onClick, src = _a.src, title = _a.title;
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme);
    var iconCss = (0, react_1.css)(active ? styles.active : disabled ? styles.disabled : styles.icon);
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ css: (0, react_1.css)(styles.button), disabled: disabled, onClick: onClick }, { children: [icon && (0, jsx_runtime_1.jsx)(Icon_1.default, { name: icon, size: 'lg', css: iconCss }, void 0), src && (0, jsx_runtime_1.jsx)(react_svg_1.ReactSVG, { css: iconCss, src: src }, void 0), title && title.length > 0 && ((0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: "textMedium" }, { children: title }), void 0))] }), void 0));
};
var Menu = function (_a) {
    var actions = _a.actions, children = _a.children, disabled = _a.disabled, editor = _a.editor, toggleShowLink = _a.toggleShowLink, linkInput = _a.linkInput;
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ css: (0, react_1.css)(styles.wrapper) }, { children: [linkInput && linkInput, !linkInput && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MenuButton, { active: editor.isActive('bold'), disabled: disabled, onClick: function () { return editor.chain().focus().toggleBold().run(); }, src: bold_svg_1.default }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { active: editor.isActive('italic'), disabled: disabled, onClick: function () { return editor.chain().focus().toggleItalic().run(); }, src: italic_svg_1.default }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { active: editor.isActive('underline'), disabled: disabled, onClick: function () { return editor.chain().focus().toggleUnderline().run(); }, src: underline_svg_1.default }, void 0), (0, jsx_runtime_1.jsx)("div", { css: (0, react_1.css)(styles.divider) }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { active: editor.isActive('bulletList'), disabled: disabled, onClick: function () { return editor.chain().focus().toggleBulletList().run(); }, src: ul_svg_1.default }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { active: editor.isActive('orderedList'), disabled: disabled, onClick: function () { return editor.chain().focus().toggleOrderedList().run(); }, src: ol_svg_1.default }, void 0), (0, jsx_runtime_1.jsx)("div", { css: (0, react_1.css)(styles.divider) }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { active: !!editor.getAttributes('link').href, disabled: disabled, onClick: function () { return toggleShowLink(true); }, src: link_svg_1.default }, void 0)] }, void 0)), !linkInput &&
                actions &&
                actions.length > 0 &&
                actions.map(function (_a, index) {
                    var onClick = _a.onClick, icon = _a.icon, customIcon = _a.customIcon, title = _a.title, active = _a.active;
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { css: (0, react_1.css)(styles.divider) }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { active: active, disabled: disabled, icon: icon, onClick: onClick, src: customIcon, title: title }, "rich-text-action--".concat(title.toLowerCase(), "--").concat(index))] }, void 0));
                }), children] }), void 0));
};
exports.Menu = Menu;
//# sourceMappingURL=Menu.js.map